/* tslint:disable */
/* eslint-disable */
export enum WebServiceState {
  Success = 'Success',
  Error = 'Error'
}
